<div class="dialog-annulation">
  <app-dialog-simple-confirmation
    [title]="textContent.confirmation | translate"
    [isVisible]="isPreautEnLigneCanceled"
    (close)="closeModal()"
  ></app-dialog-simple-confirmation>

  <div [ngClass]="{ hide: isPreautEnLigneCanceled }">
    <app-dialog-simple
      [textContent]="textContent"
      (close)="closeModal()"
      (confirm)="confirmCancel()"
      [hasCloseButton]="false"
    >
    </app-dialog-simple>
  </div>

  <div class="close-button">
    <app-dialog-close-button (buttonClick)="closeModal()"></app-dialog-close-button>
  </div>
</div>
